import { DEVELOPER_DASHBOARD_URL } from '@infura/packages.common/constants'

// @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
export const PORT = parseInt(process.env.PORT, 10) || 3000

export const PROD = !process.env.DEV && process.env.ENVIRONMENT === 'production'

export const IS_TESTING = process.env.ENVIRONMENT === 'test' && !!process.env.CI

export const PUBLIC_URL_IS_LOCALHOST = DEVELOPER_DASHBOARD_URL.indexOf('localhost') > -1

// https://vercel.com/docs/concepts/deployments/generated-urls#url-with-git-branch
const vercelUrl = `app-git-${process.env.VERCEL_GIT_COMMIT_REF}-infura-web.vercel.app`

// server needs same url logic as client build
// this url should not include https:// - https://vercel.com/docs/concepts/projects/environment-variables/system-environment-variables#system-environment-variables
export const PUBLIC_URL = DEVELOPER_DASHBOARD_URL

export const MARKETING_PREVIEW_APP_SUFFIX = '-infura-web.vercel.app' // for marketing preview apps
export const DOCS_PREVIEW_PREFIX = 'infura-docs-' // for docs preview
export const MM_DOCS_PREVIEW_PREFIX = 'metamask-docs-' // for Metamask docs preview

export const MM_DOCS_URL = 'https://docs.metamask.io'

export const INFURA_DEV_HOST = 'infuratest.io'

const DOCS_PREVIEW_URL = 'https://infura-docs-5w0z3enfz-infura-web.vercel.app'

export const PROD_WHITELIST = [
  PUBLIC_URL,
  DOCS_PREVIEW_URL,
  MM_DOCS_URL,
  ...(process.env.VERCEL ? [`https://${vercelUrl}`] : [])
]

export const LOCALHOST_WHITELIST = [`http://localhost:${process.env.PORT}`, 'http://localhost:3003']

export const TOKENS_CACHE_DURATION_SEC = 3 * 60 * 60 // 3 hours

export const PREFIX_JWT_NAME = 'inf::jwt::'

export const JWT_ISSUER = 'infura.io'

export const PROD_URL = 'https://developer.metamask.io'
